import { __decorate, __metadata } from "tslib";
import { IsNotEmptyObjectWithLVS, SupportedCurrencyEnum, TargetEnum } from '@goparrot/common';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { ArrayUnique, Equals, IsArray, IsBoolean, IsEnum, IsISO8601, IsInstance, IsNotEmpty, IsNumber, IsOptional, IsString, MaxLength, MinLength, ValidateNested, } from 'class-validator';
import { ItemBasePricingStrategyEnum, LevelTypeEnum, StoreItemTypeEnum, StoreItemsExposeGroup, TagEnum } from '../enum';
import { ReadItemBaseMetadataDto } from './ReadItemBaseMetadataDto';
import { ReadItemBaseModsDto } from './ReadItemBaseModsDto';
import { ReadItemBasePropertiesDto } from './ReadItemBasePropertiesDto';
export class ReadItemBaseDto {
}
__decorate([
    ApiProperty({ description: 'Item type', example: StoreItemTypeEnum.ITEM_BASE }),
    Expose({ groups: [StoreItemsExposeGroup.READ, StoreItemsExposeGroup.BATCH_CREATE] }),
    IsOptional({ groups: [StoreItemsExposeGroup.CREATE, StoreItemsExposeGroup.UPDATE, StoreItemsExposeGroup.PATCH] }),
    Equals(StoreItemTypeEnum.ITEM_BASE, { groups: [StoreItemsExposeGroup.BATCH_CREATE] }),
    __metadata("design:type", String)
], ReadItemBaseDto.prototype, "type", void 0);
__decorate([
    ApiProperty({ description: 'Item unique identifier', example: '567abd5b-be04-43c1-8517-b9b303b302df' }),
    Expose({ groups: [StoreItemsExposeGroup.READ, StoreItemsExposeGroup.BATCH_PATCH, StoreItemsExposeGroup.BATCH_CREATE] }),
    IsOptional({ groups: [StoreItemsExposeGroup.CREATE, StoreItemsExposeGroup.UPDATE, StoreItemsExposeGroup.PATCH] }),
    IsString({ always: true }),
    IsNotEmpty({ groups: [StoreItemsExposeGroup.BATCH_PATCH, StoreItemsExposeGroup.BATCH_CREATE] }),
    __metadata("design:type", String)
], ReadItemBaseDto.prototype, "uniqueName", void 0);
__decorate([
    ApiProperty({ description: 'Store unique identifier', example: '567abd5b-be04-43c1-8517-b9b303b302df' }),
    Expose({ groups: [StoreItemsExposeGroup.READ, StoreItemsExposeGroup.BATCH_PATCH, StoreItemsExposeGroup.BATCH_CREATE] }),
    IsOptional({ groups: [StoreItemsExposeGroup.CREATE, StoreItemsExposeGroup.PATCH, StoreItemsExposeGroup.UPDATE, StoreItemsExposeGroup.BATCH_PATCH] }),
    IsString({ always: true }),
    IsNotEmpty({ groups: [StoreItemsExposeGroup.BATCH_PATCH, StoreItemsExposeGroup.BATCH_CREATE] }),
    __metadata("design:type", String)
], ReadItemBaseDto.prototype, "storeId", void 0);
__decorate([
    ApiProperty({ description: 'Merchant unique identifier', example: 'ddfb5654-7fe1-40de-8be8-041116c8f267' }),
    Expose({ groups: [StoreItemsExposeGroup.READ, StoreItemsExposeGroup.BATCH_CREATE] }),
    IsOptional({ groups: [StoreItemsExposeGroup.CREATE, StoreItemsExposeGroup.UPDATE, StoreItemsExposeGroup.PATCH] }),
    IsString({ always: true }),
    IsNotEmpty({ groups: [StoreItemsExposeGroup.BATCH_CREATE] }),
    __metadata("design:type", String)
], ReadItemBaseDto.prototype, "merchantId", void 0);
__decorate([
    ApiProperty({ enum: LevelTypeEnum, example: LevelTypeEnum.MERCHANT }),
    Expose({ groups: [StoreItemsExposeGroup.READ, StoreItemsExposeGroup.BATCH_CREATE, StoreItemsExposeGroup.BATCH_PATCH] }),
    IsOptional({ groups: [StoreItemsExposeGroup.UPDATE, StoreItemsExposeGroup.PATCH, StoreItemsExposeGroup.BATCH_PATCH] }),
    IsEnum(LevelTypeEnum, { groups: [StoreItemsExposeGroup.BATCH_CREATE, StoreItemsExposeGroup.BATCH_PATCH] }),
    __metadata("design:type", String)
], ReadItemBaseDto.prototype, "levelType", void 0);
__decorate([
    ApiProperty({ enum: TargetEnum, example: TargetEnum.ONLINE }),
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ groups: [StoreItemsExposeGroup.CREATE, StoreItemsExposeGroup.BATCH_CREATE, StoreItemsExposeGroup.PATCH, StoreItemsExposeGroup.BATCH_PATCH] }),
    IsEnum(TargetEnum, { always: true }),
    __metadata("design:type", String)
], ReadItemBaseDto.prototype, "target", void 0);
__decorate([
    ApiProperty({ type: () => Boolean, example: false }),
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ groups: [StoreItemsExposeGroup.PATCH, StoreItemsExposeGroup.BATCH_PATCH] }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], ReadItemBaseDto.prototype, "isArchived", void 0);
__decorate([
    ApiProperty({ type: () => Boolean, example: true }),
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ groups: [StoreItemsExposeGroup.PATCH, StoreItemsExposeGroup.BATCH_PATCH] }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], ReadItemBaseDto.prototype, "isAvailable", void 0);
__decorate([
    ApiProperty({ type: () => Boolean, example: true }),
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ groups: [StoreItemsExposeGroup.PATCH, StoreItemsExposeGroup.BATCH_PATCH] }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], ReadItemBaseDto.prototype, "isOrderable", void 0);
__decorate([
    ApiProperty({ type: () => Boolean, example: true }),
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ groups: [StoreItemsExposeGroup.PATCH, StoreItemsExposeGroup.BATCH_PATCH] }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], ReadItemBaseDto.prototype, "isVisible", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, example: true }),
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ always: true }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], ReadItemBaseDto.prototype, "isVersioned", void 0);
__decorate([
    ApiProperty({ type: () => String, example: 'Delivery Lunch ItemSet', minLength: 1, maxLength: 1000 }),
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ groups: [StoreItemsExposeGroup.PATCH, StoreItemsExposeGroup.BATCH_PATCH] }),
    IsString({ always: true }),
    MaxLength(1000, { always: true }),
    __metadata("design:type", String)
], ReadItemBaseDto.prototype, "subtitle", void 0);
__decorate([
    ApiProperty({ type: () => String, example: 'TODelivery Lunch ItemSet', minLength: 1, maxLength: 255 }),
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ groups: [StoreItemsExposeGroup.PATCH, StoreItemsExposeGroup.BATCH_PATCH] }),
    IsString({ always: true }),
    MinLength(1, { always: true }),
    IsNotEmpty({ always: true }),
    MaxLength(255, { always: true }),
    __metadata("design:type", String)
], ReadItemBaseDto.prototype, "title", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, example: 'TODelivery Lunch ItemSet' }),
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], ReadItemBaseDto.prototype, "titleHTML", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, example: 'http://via.placeholder.com/1200x960.jpg' }),
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], ReadItemBaseDto.prototype, "image_url", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, example: 'http://via.placeholder.com/800x800.jpg' }),
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], ReadItemBaseDto.prototype, "image_url_square", void 0);
__decorate([
    ApiProperty({ type: () => Number, example: 9.99 }),
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ groups: [StoreItemsExposeGroup.PATCH, StoreItemsExposeGroup.BATCH_PATCH] }),
    IsNumber({}, { always: true }),
    __metadata("design:type", Number)
], ReadItemBaseDto.prototype, "price", void 0);
__decorate([
    ApiProperty({ enum: SupportedCurrencyEnum }),
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ groups: [StoreItemsExposeGroup.PATCH, StoreItemsExposeGroup.BATCH_PATCH] }),
    IsEnum(SupportedCurrencyEnum, { always: true }),
    __metadata("design:type", String)
], ReadItemBaseDto.prototype, "currency", void 0);
__decorate([
    ApiProperty({ type: () => String, isArray: true }),
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ groups: [StoreItemsExposeGroup.PATCH, StoreItemsExposeGroup.BATCH_PATCH] }),
    IsArray({ always: true }),
    ArrayUnique({ always: true }),
    __metadata("design:type", Array)
], ReadItemBaseDto.prototype, "itemSet", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, example: 'ddfb5654-7fe1-40de-8be8-041116c8f267' }),
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], ReadItemBaseDto.prototype, "globalIdentifier", void 0);
__decorate([
    ApiProperty({ type: () => ReadItemBaseMetadataDto }),
    Type(() => ReadItemBaseMetadataDto),
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ groups: [StoreItemsExposeGroup.PATCH, StoreItemsExposeGroup.BATCH_PATCH] }),
    ValidateNested({ always: true }),
    IsInstance(ReadItemBaseMetadataDto, { always: true }),
    IsNotEmptyObjectWithLVS({ always: true }),
    __metadata("design:type", ReadItemBaseMetadataDto)
], ReadItemBaseDto.prototype, "metadata", void 0);
__decorate([
    ApiPropertyOptional({ type: () => ReadItemBaseModsDto, isArray: true }),
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    Type(() => ReadItemBaseModsDto),
    IsOptional({ always: true }),
    IsArray({ always: true }),
    ValidateNested({ each: true, always: true }),
    IsInstance(ReadItemBaseModsDto, { each: true, always: true }),
    __metadata("design:type", Array)
], ReadItemBaseDto.prototype, "mods", void 0);
__decorate([
    ApiPropertyOptional({ type: () => ReadItemBasePropertiesDto, isArray: true }),
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    Type(() => ReadItemBasePropertiesDto),
    IsOptional({ always: true }),
    IsArray({ always: true }),
    IsInstance(ReadItemBasePropertiesDto, { each: true, always: true }),
    ValidateNested({ each: true, always: true }),
    __metadata("design:type", Array)
], ReadItemBaseDto.prototype, "properties", void 0);
__decorate([
    ApiPropertyOptional({ enum: ItemBasePricingStrategyEnum }),
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ always: true }),
    IsEnum(ItemBasePricingStrategyEnum, { always: true }),
    __metadata("design:type", String)
], ReadItemBaseDto.prototype, "pricingStrategy", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, example: 'Some internal Name', minLength: 1, maxLength: 255 }),
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    MaxLength(255, { always: true }),
    __metadata("design:type", String)
], ReadItemBaseDto.prototype, "internalName", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Date, format: 'date-time', example: '2017-11-27T09:47:45.257+0000' }),
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ always: true }),
    IsISO8601({}, { always: true }),
    __metadata("design:type", Object)
], ReadItemBaseDto.prototype, "isAvailableAt", void 0);
__decorate([
    ApiPropertyOptional({ enum: TagEnum, isArray: true, example: TagEnum.FRANCHISE }),
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ always: true }),
    IsArray({ always: true }),
    IsEnum(TagEnum, { each: true, always: true }),
    __metadata("design:type", Array)
], ReadItemBaseDto.prototype, "tags", void 0);
//# sourceMappingURL=ReadItemBaseDto.js.map